export const typo = {
  fontFamily: 'Inter',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '146%',
  color: '#23252f',
};

export const filtersStyles = {
  popper: {
    '& .MuiPopover-paper': {
      boxShadow: 'none',
    },
    '& .MuiPaper-root': {
      padding: '20px',
      width: '700px',
      marginTop: '4px',
      boxShadow: 'none',
    },
    '& form': {
      display: 'flex',
      flexDirection: 'column',
      gap: '40px',
    },
  },
  inputsWrapper: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, calc((100% - 24px) / 2))',
    gap: '24px',
  },
  mainButton: {
    ...typo,
    padding: '7px 12px',
    maxHeight: '36px',
    minWidth: 'unset',
    textTransform: 'capitalize',
    background: '#fff !important',
    border: '1px solid #EDEFF7',
    borderRadius: '8px',
    gap: '8px',
    '&.active, &:focus-visible': {
      background: '#F3F4F9 !important',
      filter: 'drop-shadow(0px 0px 2px #4d6ef5)',
    },
    '& .MuiButton-startIcon': {
      margin: 0,
    },
  },
  clearBtn: {
    ...typo,
    textTransform: 'capitalize',
    background: '#fff !important',
    marginRight: 'auto',
  },
  formActions: {
    padding: '20px 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '12px',
    '&.small': {
      padding: 0,
    },
  },
  formActionButton: {
    ...typo,
    color: '#4D6EF5',
    backgroundColor: '#fff',
    textTransform: 'capitalize',
    border: '1px solid #4D6EF5',
    borderRadius: '8px',
    padding: '7px 12px',
    '&:hover': {
      opacity: '0.8',
    },
    '&.filled': {
      color: '#fff',
      backgroundColor: '#4D6EF5',
      '&:hover': {
        color: '#fff',
        backgroundColor: '#4D6EF5',
        opacity: '0.8',
      },
    },
  },
  switchesWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    gap: '32px',
    marginTop: '24px',
  },
  switchContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '8px',
  },
  optionStyles: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '146%',
    color: '#131F1E',
  },
  clearButton: {
    background: 'transparent',
    border: 'none',
    padding: '0',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '146%',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    color: '#23252F',
    transition: '300ms',
    textTransform: 'none',
    minWidth: 'auto',
  },
  btnsContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  count: {
    width: '24px',
    height: '24px',
    background: '#E7ECFF',
    borderRadius: '8px',
    padding: '2px 4px',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px !important',
    lineHeight: '146%',
    textAlign: 'center',
    color: '#23252F',
  },
  multipleSelectOption: {
    width: 'calc(100% - 12px)',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    fontSize: '14px',
    lineHeight: '146%',
    fontWeight: '400',
    color: '#23252F',
    fontFamily: 'Inter,sans-serif!important',
  },
};
